import React, {useEffect, useRef, useState} from "react";
import commonHeader from "../../assets/img/commonHeader.png";
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import {BiCaretDown} from "react-icons/bi";
import {useTranslation} from "react-i18next";
import i18n from "../../i18n";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserFaqPg() {

    const navigate = useNavigate();
    const {t} = useTranslation();
    const [theme] = useTheme();

    const moveToDetail = ((seqNum) => {
        navigate(`/UserFaqDtPg/${seqNum}`)
    })

    const [currentLang, setCurrentLang] = useState(null);
    const currentLangUpdate = (() => {
        setCurrentLang(i18n.language || 'ko')
    })

    useEffect(() => {
        currentLangUpdate();
    }, [i18n.language]);

    useEffect(() => {
        let lang;
        if (currentLang === 'en') {
            lang = '1';
        } else if (currentLang === 'ja') {
            lang = '2';
        } else if (currentLang === 'zh') {
            lang = '3';
        } else if (currentLang === 'id') {
            lang = '4';
        } else {
            lang = '0';
        }
        selectDtList(null, lang)
        selectMstTab(lang);
    }, [currentLang]);


    useEffect(() => {
        setSelectedMstTab("전체");
    }, [])

    const [faqMstList, setFaqMstList] = useState([]);
    const [selectedMstTab, setSelectedMstTab] = useState('');
    const selectMstTab = ((lang) => {
        axios({
            method: 'get',
            url: '/faq/selectMstTab/',
            params: {
                lang: lang
            }
        })
            .then((response) => {
                const titles = response.data.map(item => item.title);
                setFaqMstList(titles);
            })
    })

    const [faqDtList, setFaqDtList] = useState([]);
    const selectDtList = ((title, lang) => {
        axios({
            method: 'get',
            url: '/faq/selectDtList/',
            params: {
                title: title,
                lang: lang
            }
        })
            .then((response) => {
                const data = response.data.sort((a, b) => b.seqNum - a.seqNum);
                setFaqDtList(data);
            })
    })

    // 여기서부터 커스텀 셀렉트
    const [mstShow, setMstShow] = useState(false);
    const faqMstRef = useRef(null);

    const toggleMstShow = () => {
        setMstShow(!mstShow);
    };

    const handleMstChange = (title) => {
        let lang;
        if (currentLang === 'en') {
            lang = '1';
        } else if (currentLang === 'ja') {
            lang = '2';
        } else if (currentLang === 'zh') {
            lang = '3';
        } else if (currentLang === 'id') {
            lang = '4';
        } else {
            lang = '0';
        }
        selectDtList(title, lang);
        setSelectedMstTab(title === null ? "전체" : title);
        setMstShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (faqMstRef.current && !faqMstRef.current.contains(event.target)) {
                setMstShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // 여기까지 커스텀 셀렉트

    const formatDate = (dateStr) => {
        if (dateStr?.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    const fixedList = faqDtList.filter(data => data.fixFl === true);
    const normalList = faqDtList.filter(data => data.fixFl === false);

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" alt="faq" src={commonHeader}/>
                    <p className="up-head-title">{t(`fHeader`)}</p> {/*자주묻는질문*/}
                </div>
                <div className="up-head-spacer"/>
                <div className="up-head-r">
                    {/*커스텀 분류 셀렉트*/}
                    <div ref={faqMstRef} style={{position: "relative", width: "200px", maxWidth: "55vw", height: "40px"}}>
                        <button className="selectParentBt" style={{width: "100%", height: "100%"}}
                                onClick={toggleMstShow}>
                            <p style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{selectedMstTab}</p>
                            <span style={{marginLeft: "auto", display: "flex", alignItems: "center", opacity: "0.5"}}>
                                <BiCaretDown/>
                            </span>
                        </button>
                        {mstShow ?
                            <div className="up-select-pop" style={{
                                position: "absolute",
                                width: "100%",
                                marginTop: "6px",
                                maxHeight: "400px",
                                overflowY: "auto",
                                overscrollBehavior: "contain",
                                WebkitOverflowScrolling: "touch",
                                zIndex: 5,
                                minHeight: "40px"
                            }}>
                                <div className="selectChildBt" value="전체"
                                     onClick={() => handleMstChange(null)} style={{
                                    display: "flex", padding: "10px", justifyContent: "center",
                                    alignItems: "center", cursor: "pointer", fontSize: "14px"
                                }}>{t(`all`)}</div>
                                {faqMstList.map((mst, index) => (
                                    <div key={index} className="selectChildBt" value={selectedMstTab}
                                         onClick={() => handleMstChange(mst)} style={{
                                        display: "flex", padding: "10px", justifyContent: "center",
                                        alignItems: "center", cursor: "pointer", fontSize: "13px"
                                    }}>{mst}</div>
                                ))}
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </div>

            <div className="up-list up-scroll-x">
                <div className="up-scroll-inner">
                    <div className="up-thead">
                        <div className="c" style={{width: "10%"}}>{t(`fSmallMenu1`)}</div>
                        <div className="c" style={{width: "10%"}}>{t(`fSmallMenu5`)}</div>
                        <div className="c" style={{width: "20%"}}>{t(`fSmallMenu2`)}</div>
                        <div className="c" style={{width: "45%"}}>{t(`fSmallMenu3`)}</div>
                        <div className="c" style={{width: "15%"}}>{t(`fSmallMenu4`)}</div>
                    </div>
                    <div className="up-tbody">
                        {fixedList.map((dt, i) => (
                            <div key={`fix-${i}`} onClick={() => moveToDetail(dt.seqNum)} className="up-trow">
                                <div className="c" style={{width: "10%"}}><span className="up-badge-fix">{t(`fdFix`)}</span></div>
                                <div className="c sub" style={{width: "10%"}}>{formatDate(dt?.regDate)}</div>
                                <div className="c" style={{width: "20%"}}><span className="up-tag">[{dt?.faqMstDTO?.title}]</span></div>
                                <div className="c title" style={{width: "45%"}}>{dt?.title}</div>
                                <div className="c sub" style={{width: "15%"}}>{dt?.regNm}</div>
                            </div>
                        ))}
                        {normalList.map((dt, i) => (
                            <div key={`n-${i}`} onClick={() => moveToDetail(dt.seqNum)} className="up-trow">
                                <div className="c sub" style={{width: "10%"}}>{i + 1}</div>
                                <div className="c sub" style={{width: "10%"}}>{formatDate(dt?.regDate)}</div>
                                <div className="c" style={{width: "20%"}}><span className="up-tag">[{dt?.faqMstDTO?.title}]</span></div>
                                <div className="c title" style={{width: "45%"}}>{dt?.title}</div>
                                <div className="c sub" style={{width: "15%"}}>{dt?.regNm}</div>
                            </div>
                        ))}
                        {faqDtList.length === 0 &&
                            <div className="up-empty">{t(`fHeader`)}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserFaqPg
